import { render, staticRenderFns } from "./DeviceTableComponent.vue?vue&type=template&id=ed3aa22e&scoped=true&"
import script from "./DeviceTableComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTableComponent.vue?vue&type=style&index=0&id=ed3aa22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3aa22e",
  null
  
)

export default component.exports